import React from 'react'
import ContentLoader from 'react-content-loader'

const Loader = ({ pageRange }) => {
    const height = 55 * (pageRange + 1)
    const body = new Array(pageRange + 1).fill(null).map((i, ind) => {
        let yStrip = ind ? (57 * ind + 15) + "" : "15"
        if (ind === 0) {
            yStrip = '15'
        } else {
            if (ind === 1) {
                yStrip = '55'
            } else {
                yStrip = 57 * (ind - 1) + 57 + ''
            }
        }
        return (
            <React.Fragment key={ind}>                
                {
                    ind ?
                    <>
                        <rect x="15" y={yStrip} rx="3" ry="3" width="170" height="15" />
                        <rect x="330" y={yStrip} rx="3" ry="3" width="170" height="15" />
                        <rect x="650" y={yStrip} rx="3" ry="3" width="150" height="15" />
                        <rect x="863" y={yStrip} rx="3" ry="3" width="120" height="25" />
                        <rect x="1000" y={yStrip} rx="3" ry="3" width="15" height="10" />                        
                    </> :
                    <>
                        <rect x="15" y={yStrip} rx="3" ry="3" width="40" height="15" />
                        <rect x="330" y={yStrip} rx="3" ry="3" width="110" height="15" />
                        <rect x="650" y={yStrip} rx="3" ry="3" width="120" height="15" />
                        <rect x="863" y={yStrip} rx="3" ry="3" width="40" height="15" />
                    </>
                }
            </React.Fragment>
        )
    })

    return (
        <ContentLoader
            speed={2}
            width={1167}
            height={height}
            viewBox={`0 0 1167 ${height}`}
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
        >
            <>
                {body}
            </>        
        </ContentLoader>
    )
}

export default Loader